import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { IconButton, Grid, Tooltip } from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  Done,
  Clear,
  Sort,
} from "@mui/icons-material";
import { Dropdown, Modal } from "antd";
import { ListItemParcedModal } from "./listItemParcedModal";
import { moduleActions } from "../../../../../../Global/Permission/constants";
import { validatePermission } from "../utils/validatePermission";
import { openNotification } from "../../../../../Components/Notification";
import createModal from "../../../../../Components/ModalV2";

const ListItemsTitle = ({
  item,
  index,
  handleExpand,
  handleEditItem,
  handleUpdateStatus,
  t,
  parcedPOItem,
  rolId,
  canEditItems,
}) => {
  const [open, setOpen] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [message, setMessage] = useState("");

  const { confirm } = Modal;

  const toggle = () => {
    setOpen(!open);
  };

  const handleEdit = () => {
    handleExpand(index, true);
    handleEditItem(index, !item.edit);
  };

  const handleOptions = (status) => {
    let title = t("resume.itemsCollapse.statusAccepted");
    if (status === 49) {
      title = t("resume.itemsCollapse.statusRejected");
    } else if (status === 50) {
      title = t("resume.itemsCollapse.statusCanceled");
    }
    setStatus(status)
    setModalConfirm(true)
    setMessage(title)
  };

  const items = [
    {
      key: "1",
      label: <span className="label-euro">{t("edit")}</span>,
      icon: <span className="icon-edit" />
    },
    {
      key: "2",
      label: <span className="label-euro">{t("accept")}</span>,
      icon: <Done />,
    },
    {
      key: "3",
      label: <span className="label-euro">{t("reject")}</span>,
      icon: <Clear fontSize="small" />,
    },
    {
      key: "4",
      label: <span className="label-euro">{t("cancel")}</span>,
      icon: <Clear fontSize="small" />,
    },
    {
      key: "5",
      label: <span className="label-euro">{t("resume.shared.parced")}</span>,
      icon: <Sort />,
    },
  ];

  const handleDropdown = (e) => {
    switch (e.key) {
      case "1":
        handleEdit();
        break;
      case "2":
        handleOptions(48);
        break;
      case "3":
        handleOptions(49);
        break;
      case "4":
        handleOptions(51);
        break;
      case "5":
        setOpen(true);
        break;
      default:
        break;
    }
  };

  const filterMenu = () => {
    let menu = [];
    if (validatePermission(rolId, moduleActions.SUPPLIER_MANAGEMENT_EDIT_ITEM)) menu.push(items[0]);
    return menu;
  };

  const update = async () => {
    try {
      await parcedPOItem(item.POItemsId);
      openNotification('success', t("resume.itemsCollapse.parcedModal.success"));

    } catch (err) {
      console.log("error en parced", err);
      openNotification('error', t("resume.itemsCollapse.parcedModal.error"));
    }
  };

  const truncateDescription = (description) => {
    if (description.length > 40) {
      return (
        <Tooltip
          placement="bottom"
          title={
            <label
              className="label-euro normal">
              {description}
            </label>
          }
        >
          <span className="label-euro normal">
            {description.substring(0, 37) + "..."}
          </span>
        </Tooltip>
      );
    }
    return <span className="label-euro normal">{description}</span>;
  };

  return (
    <>
      <ListItemParcedModal
        open={open}
        toggle={toggle}
        t={t}
        update={update}
        item={item}
      />
      <Grid container spacing={0} alignItems="center">
        <Grid xs={1} container>
          <IconButton onClick={() => handleExpand(index)}>
            {item.expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
          <IconButton>
            {
              /* no mostrar opcion de editar */
              canEditItems && [46, 47, 49, 48, 52].includes(item.StatusIdItemPM) ?
                <Dropdown
                  menu={{
                    items: filterMenu(),
                    onClick: handleDropdown,
                  }}
                  trigger={["click"]}
                  placement="bottom"
                >
                  <span className="icon-po-visibility-tablemenu icons-front-module" style={{ color: '#000a2e' }} />
                </Dropdown>
                : false
            }

          </IconButton>
        </Grid>
        <Grid xs={2}>
          <label className="label-euro bold">
            {t("resume.itemsCollapse.line")}:{" "}
            <span className="label-euro normal">{item.LineNo}</span>
          </label>
        </Grid>
        <Grid xs={2}>
          <label className="label-euro bold">
            {t("resume.itemsCollapse.item")}:{" "}
            <span className="label-euro normal">{item.ItemNo}</span>
          </label>
        </Grid>
        <Grid xs={2} paddingLeft="8px" paddingRight="8px">
          <label className="label-euro bold">
            {t("resume.itemsCollapse.description")}:{" "}
            {truncateDescription(item.Description)}
          </label>
        </Grid>
        <Grid container xs={3}>
          <Grid xs={6}>
            <label className="label-euro bold">
              {t("resume.shared.qtyOrdered")}:{" "}
              <span className="label-euro normal">{item.QTYOrdered}</span>
            </label>
          </Grid>
          <Grid xs={6}>
            <label className="label-euro bold">
              {t("resume.shared.qtyConfirmed")}:{" "}
              <span className="label-euro normal">{item.QTYConfirmed}</span>
            </label>
          </Grid>
        </Grid>
        <Grid xs={2}>
          <span class="badge badge-euro">{item.Status}</span>
        </Grid>
      </Grid>

      {createModal({
        isModalOpen: modalConfirm,
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{message}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: t('No'),
            onClick: () => setModalConfirm(false),
            type: "secondary",
          },
          {
            text: t('yes'),
            onClick: async () => {
              try {
                await handleUpdateStatus(item, status);
                openNotification('success', t("purchase_order_item_successfully_updated"));
              } catch (err) {
                console.log("error en update status", err);
                openNotification('error', t("purchase_order_item_error_updated"));
              }
            },
            type: "primary",
          }
        ],
        onCancel: () => setModalConfirm(false)
      })}
    </>
  );
};

export default withNamespaces()(withRouter(ListItemsTitle));
